module.exports = __webpack_public_path__ + "static/vikas_kalwani-23581fae09cfaba1d5f5c5c5399fb559.png";